var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 98,
    viewBox: "0 0 130 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M63.3195 86.233C88.0661 86.233 108.127 84.3061 108.127 81.9291C108.127 79.5522 88.0661 77.6252 63.3195 77.6252C38.5728 77.6252 18.5117 79.5522 18.5117 81.9291C18.5117 84.3061 38.5728 86.233 63.3195 86.233Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.8501 22.1966C98.0071 25.483 109.2 35.8493 112.476 49.2063C114.917 59.137 112.775 69.3603 96.3528 73.0986C60.8433 81.1504 22.4933 78.4914 17.8978 62.3909C13.3023 46.2904 21.8303 18.6664 42.1331 16.9565C53.6933 15.9813 71.0451 19.232 83.8501 22.1966Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9031 50.1937L63.4033 45.2598V83.8698L83.9031 78.5075V50.1937Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M83.9031 50.1937L63.4033 45.2598V83.8698L83.9031 78.5075V50.1937Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9033 50.1937L63.4031 45.2598V83.8698L42.9033 78.6149V50.1937Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M42.9033 50.0226L63.4031 45.0896V83.8698L42.9033 78.6149V50.0226Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2314 45.4309L74.0285 36.4651L94.5273 41.721L83.7312 50.3639L63.2314 45.4309Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5557 41.9985L43.074 50.3639L63.5728 45.4309L53.1628 36.6362L32.5557 41.9985Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M32.3857 41.8283L43.1596 50.3639L63.6593 45.4309L52.9919 36.4651L32.3857 41.8283Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9033 50.1937V78.6149L63.4031 83.8698L63.6798 55.6633L42.9033 50.1937Z",
    fill: "#E6E6E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9031 78.5076L63.4033 83.8698V55.6633L83.9031 50.1937V78.5076Z",
    fill: "#E6E6E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M83.9031 78.5076L63.4033 83.8698V55.6633L83.9031 50.1937V78.5076Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M75.7451 69.0689V78.4002L83.9026 76.1474V66.8171L75.7451 69.0689Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.6348 64.9404L54.1188 67.8362L63.3493 60.3284V55.7165L42.8496 50.5688L42.6348 64.9404Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.0632 64.9404L72.5792 67.8362L63.3496 60.3284V55.7165L83.8484 50.5688L84.0632 64.9404Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9032 50.1937L32.3857 58.8811L52.8845 64.0287L63.4029 55.6633L42.9032 50.1937Z",
    fill: "#E6E6E6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9031 50.1937L94.5279 58.8811L74.1355 64.0287L63.4033 55.6633L83.9031 50.1937Z",
    fill: "#E6E6E6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M83.9031 50.1937L94.5279 58.8811L74.1355 64.0287L63.4033 55.6633L83.9031 50.1937Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataEmpty);
export default __webpack_public_path__ + "static/media/data_empty.3b443938dae70f56799b83342f8d39e7.svg";
export { ForwardRef as ReactComponent };